module.exports = __webpack_public_path__ + "static/media/virtualEvents.f817e9de.png";